// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EaFa","right":"styles_right__1hBh5"};